import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { CustomPageBlockComponent } from './custom-page-block.component';

/**
 * Display a YouTube video embed.
 */
@Component({
  selector: 'app-custom-page-youtube-video',
  template: `<div
    class="mx-auto"
    [ngClass]="{
      'max-w-[60%]': data().size === 'small',
      'max-w-screen-lg': data().size === 'standard',
      'max-w-screen-xl': data().size === 'wide',
      'px-8': data().size !== 'full_width',
    }"
  >
    <iframe type="text/html" class="aspect-video w-full" [src]="url()" frameborder="0"></iframe>
  </div>`,
  imports: [CommonModule],
  standalone: true,
})
export class CustomPageYouTubeVideoComponent extends CustomPageBlockComponent<'youtube_video'> {
  #sanitizer = inject(DomSanitizer);
  protected url = computed(() =>
    this.#sanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${this.data().identifier}`),
  );
}
